import React from 'react' 
import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font'; 



export default class CardholderReveiw extends React.Component{


    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
            
        }
    }

    
    render(){
        const {data} = this.props

        if(data.index===0)  //primary cardholder
            return(
                <div style={{background:"#FFF",width:"46.3vw",height:'auto', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:"2.4vh", paddingLeft:'2.8vh',paddingRight:'2.8vh',paddingTop:'2.4vh'}}>{/**My Active Cards Container*/}
                    <div style={{display:'flex', justifyContent:'space-between',marginTop:'1vh',marginBottom:'3vh'}} ><span style={{...Fonts.supertitle, color:Colors.black}}>Primary Cardholder</span>  </div>
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between',marginBottom:'5vh',marginTop:'4vh'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>First Name</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.firstname}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Date of Birth</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.dob}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Address</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.address}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>State</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.state}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Email</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.email}</span>
                        </div>
                    </div>
                    <div style={{display:'flex',flexDirection:'column'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Last Name</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.lastname}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Social Security</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.ssn}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>City</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.city}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Zip</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.zip}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Contact Phone</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.phone}</span>
                        </div>
                    </div>
                    <div style={{display:'flex',flexDirection:'column',marginTop:'19vh',marginRight:'5vw'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Country</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.country}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Work Phone</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.workphone}</span>
                        </div>
                    </div>
                    </div>
                </div>
            )
        else  //secondary cardholder
        return(
            <div style={{background:"#FFF",width:"46.3vw",height:'auto', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:"2.4vh", paddingLeft:'2.8vh',paddingRight:'2.4vh',paddingTop:'2.4vh'}}>{/**My Active Cards Container*/}
                <div style={{display:'flex', justifyContent:'space-between',marginTop:'1vh',marginBottom:'3vh'}} ><span style={{...Fonts.supertitle, color:Colors.black}}>Cardholder</span> </div>
                <div style={{display:'flex',flexDirection:'column',marginTop:'5vh'}}>
                    <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Relationship with primary card holer</span><span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.relationship}</span>
                </div>
                <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between',marginBottom:'4vh'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>First Name</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.firstname}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Date of Birth</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.dob}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Address</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.address}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>State</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.state}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Email</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.email}</span>
                        </div>
                    </div>
                    <div style={{display:'flex',flexDirection:'column'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Last Name</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.lastname}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Social Security</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.ssn}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>City</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.city}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Zip</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.zip}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Contact Phone</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.phone}</span>
                        </div>
                    </div>
                    <div style={{display:'flex',flexDirection:'column',marginTop:'19vh',marginRight:'5vw'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Country</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.country}</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                            <span style={{...Fonts.subtext,textAlign:'left',color:Colors.dark_grey}}>Work Phone</span>
                            <span style={{...Fonts.subtitle,marginTop:'0.7vh',marginBottom:'2.5vh'}}>{data.workphone}</span>
                        </div>
                    </div>
                    </div>
                </div>
        )
    }
}